import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppRemixIcon } from '@/layout/AppComponents';
import { useNavigate, useParams } from 'react-router-dom';
import ReactDOMServer from 'react-dom/server';
import { path } from '../../../../../../routing/helpers/router';
import * as currentPageAction from '../../../../../../store/actions/currentPageAction';
import Translator from '../../../../../components/helpers/Translator';
import _ from 'lodash';

export default function GoToMarker() {
  const { moduleBridgeHex, plantHex, filtersHex } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userMarkPoID = useSelector(
    (state) => state.currentPage?.options?.userMark
  );
  const plantObligations = useSelector(
    (state) => state.currentPage?.gcl?.plantObligations
  );

  const handleGoToMarker = useCallback(() => {
    if (userMarkPoID && plantObligations !== undefined) {
      dispatch(currentPageAction.change('goToMark', true, true));
      navigate(
        path({
          name: 'user_module_legalCompliance_evaluation',
          params: {
            moduleBridgeHex,
            plantHex,
            page:
              parseInt(
                _.findKey(plantObligations, (p) => p.includes(userMarkPoID))
              ) + 1,
            filtersHex,
          },
        })
      );
    }
  }, [userMarkPoID, plantObligations, moduleBridgeHex, plantHex]);

  return (
    <li
      title={ReactDOMServer.renderToString(
        <Translator file="module-legalCompliance" name="go.marker.page" />
      )}
      className={`pointer ${
        userMarkPoID !== undefined &&
        userMarkPoID !== null &&
        plantObligations !== undefined
          ? ''
          : 'off'
      }`}
    >
      <AppRemixIcon
        icon="map-pin-user"
        size={20}
        onClick={() => handleGoToMarker()}
      />
    </li>
  );
}
